import React from 'react';
import Grid from "@mui/material/Grid";
import DropZone from "../../components/InvoiceDropZone";
import SubmitButtonDisplayer from "../../components/SubmitButtonDisplayer";
import { ACCESS, ACCESS_SECTIONS } from '../../utils/constants/access';
import { checkAccess } from '../../utils/roleFunctions';
import { adalApiFetch } from '../../../adalConfig';

const UploadBill = (props) => {
    const uri = process.env.REACT_APP_BASE_URL;
    const [files, setFiles] = React.useState([]);
    const [error, setError] = React.useState(null);
    const [loading, setLoading] = React.useState(false);
    const [completed, setCompleted] = React.useState(props.completed);
    const [dropzoneKey, setDropzoneKey] = React.useState(0);
    const requiredEditAccess = { key: ACCESS_SECTIONS.MYOB_PROCUREMENT, value: ACCESS.EDIT };

    const submit = async () => {
        setLoading(true);
        setError(null);

        try {
            if (files.length === 0) {
                setError('Select one or more PDFs to upload.');
                return;
            }

            const formdata = new FormData();
            files.forEach(file => formdata.append('files', file, file.name));

            const requestOptions = { method: 'POST', body: formdata, redirect: 'follow' };
            const response = await adalApiFetch(fetch, uri + '/APBills/Upload', requestOptions);
            if (!response.ok) {
                setError('An error occurred uploading the invoices');
                return;
            }

            console.log(response);
            setCompleted(true);
        } catch (err) {
            console.error(err);
            setError('An error occurred uploading the invoices');
        } finally {
            setLoading(false);
        }
    };

    // Reload/Reset DropZone on close
    const handleClose = () => {
        setCompleted(false);
        setFiles([]);          // clear selected files
        setError(null);        // clear any error message
        setDropzoneKey(k => k + 1); // force DropZone to remount
    };

    return (
        <React.Fragment>
            <Grid container spacing={2} mb={1}>
                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                        <DropZone key={dropzoneKey} files={files} setFiles={setFiles} multiple />
                    </Grid>
                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                        <div style={{ paddingTop: '5px', textAlign: 'left' }}>
                            <SubmitButtonDisplayer
                                error={error}
                                completed={completed}
                                loading={loading}
                                allowed={checkAccess(props.access, requiredEditAccess)}
                                submitFunc={submit}
                                handleClose={handleClose}
                            />
                        </div>
                    </Grid>
                </Grid>
            </Grid>
        </React.Fragment>
    );
};

export default UploadBill;